export enum BANKING_CHARGE_STATUS {
  PENDING = 'PENDING',
  RECEIVED = 'RECEIVED',
  OVERDUE = 'OVERDUE',
  CANCELED = 'CANCELED',
}
